import { environment } from '../../environments/environment';
import { loggedInToken, logout } from '../utils';

const ApiHeaders = (needsAuth: boolean, isImage?: boolean) => {
  const headers = new Headers();

  headers.append('Access-Control-Allow-Origin', '*');
  headers.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
  // if uploading image check headers

  if (!isImage) {
    headers.append('Accept', 'application/json, text/plain, */*');
    headers.append('Content-Type', 'application/json');
  }

  if (needsAuth) {
    headers.append('Authorization', `Bearer ${loggedInToken()}`);
  }

  return headers;
};

export class HttpRequestError extends Error {
  public readonly httpCode: number;

  constructor(
    httpCode: number,
    description: string
  ) {
    super(description);
    // Restore the prototype chain, as the 'super' call breaks it
    Object.setPrototypeOf(this, new.target.prototype);
    this.httpCode = httpCode;
  }
}

export const ApiClient = (apiUrl: string, jwt: string) => {
  const finalUrl = `${environment.apiHost}/api/v1${apiUrl}`;
  const options: RequestInit = { method: '' };
  const Api = {
    get: async () => await result('get'),
    post: async <T>(params?: T) => await result<T>('post', params),
    patch: async <T>(params?: T) => await result<T>('patch', params),
    delete: async <T>(params?: T) => await result<T>('delete', params),
  };

  const result = async <T>(method: string, params?: T) => {
    options.headers = ApiHeaders(false, false);
    if(apiUrl.includes('business')){
      options.headers.append("token", jwt);
    }

    options.method = method.toUpperCase();

    try {
      const response = await fetch(finalUrl, options);

      if (!response.ok) {
        if (response.status === 401 ){
          const json = await response.json();
          throw new HttpRequestError(response.status, JSON.stringify(json));
        }
      }

      const json = await response.json();
      return json;
    } catch (error: any) {
        return { error: JSON.parse(error.message) }
    }
  };

  return Api;
};
